import React from "react";
import type { Investment } from "@interfaces/investment";
import * as Styled from "./Styled";
import Button from "@components/ui/button";
import { InvestmentCardColumns } from "./investmentCardColumns";
import INVESTABLE_TYPE_PROPS from "@components/pages/investable/investable-type-props";

type Props = {
  investment: Investment;
  investableType: keyof typeof INVESTABLE_TYPE_PROPS;
  availableRewardsPercentage: number;
};

export const InvestmentCard: React.FC<Props> = ({
  investment,
  investableType,
  availableRewardsPercentage,
}) => {
  const { id, opportunity } = investment;

  const { code, precatorio } = opportunity;

  const { label, shareName } = INVESTABLE_TYPE_PROPS[investableType];

  return (
    <Styled.InvestmentCardContent>
      <Styled.OpportunityCode>
        <h1>{label}</h1>#{code}
      </Styled.OpportunityCode>

      {precatorio && <p>Venc. {precatorio.ano_vencimento}</p>}

      <InvestmentCardColumns
        investment={investment}
        shareName={shareName}
        availableRewardsPercentage={availableRewardsPercentage}
      />

      <Button
        variant="primary"
        size="sm"
        rounded
        href={`/meus_investimentos/${investableType}/${id}`}
      >
        Ver mais
      </Button>
    </Styled.InvestmentCardContent>
  );
};
